import ServiceExec from '@/common/utils/ServiceExec';
import { anniversary, memorial } from '@/common/service/apiList';
import { asFormData, isEmpty, REMOVE_EMPTY_PARAMS } from '@/common/utils/Util';
import { cloneDeep } from 'lodash';
import store from '@/store';
import { CODE_ENV_LIST, MEMORIAL_TYPE } from '@/common/constants/ConstCode';
import { showTextModal } from '@/common/utils/ModalState';
import dayjs from 'dayjs';
import { nativeDownload } from '@/common/utils/module/NativeRequest';
const {
  getList,
  getDetail,
  getChurchMemorials,
  getComment,
  pushComment,
  getAliveList,
  addReport,
  deleteAlive,
  getAliveDetail,
  saveMemorial,
  churchGrant,
  editMemorial,
  getHistoryList,
  saveAlive,
  updateAlive,
  deleteMemorial,
  getBackground,
  getAndersenBackground,
  getBackgroundVideo,
  getFrame
} = memorial;

const { getAnniversary } = anniversary;

export default {
  async excelDownload({ state }, memorialNo) {
    const response = await ServiceExec.get(`/api/memorial/comment/excel/download/` + memorialNo);
    if (response.status !== ServiceExec.status.OK) {
      return false;
    }
    const today = dayjs().format('_YYYYMMDD');
    nativeDownload(
      CODE_ENV_LIST.DYNAMIC_DOMAIN + '/excel/download/' + memorialNo,
      `추모관_헌화하기_리스트_${today}.xlsx`
    );

    return true;
  },
  async getMemorials({ commit, getters, state }, payload) {
    // userNo OR familyCode가 페이로드내에 있다면 인사이드,아웃사이드 구분하지않고 모두 가져옴
    if (payload.userNo) {
      delete state.condition.isInside;
    } else {
      state.condition.memorialType = getters['getMemorialType'];
    }

    // 검색으로 접근시 payload가 없을 수가 없기때문에 payload가 없다면 무한스크롤로인한 페이징처리로 condition을 덮어쓰지않음
    let reqData = cloneDeep(state.condition);

    if (reqData.page > state.pageInfo.endPage) return;
    if (!isEmpty(payload)) {
      Object.assign(reqData, payload);
    }

    const { data, status } = await ServiceExec.get(getList, { ...REMOVE_EMPTY_PARAMS(reqData) });
    if (ServiceExec.status.OK !== status) return;
    const { list, pageInfo } = data;
    if (isEmpty(list)) return;
    reqData.page = reqData.page + 1;
    commit('setCondition', reqData);
    commit('setPageInfo', pageInfo);
    commit('setMemorials', list);
  },
  async getMemorials2({ commit, getters, state }, payload) {
    // userNo OR familyCode가 페이로드내에 있다면 인사이드,아웃사이드 구분하지않고 모두 가져옴
    if (payload.userNo) {
      delete state.condition.isInside;
    } else {
      state.condition.memorialType = getters['getMemorialType'];
    }

    // 검색으로 접근시 payload가 없을 수가 없기때문에 payload가 없다면 무한스크롤로인한 페이징처리로 condition을 덮어쓰지않음
    let reqData = cloneDeep(state.condition);

    if (reqData.page > state.pageInfo.endPage) return;
    if (!isEmpty(payload)) {
      Object.assign(reqData, payload);
    }

    const { data, status } = await ServiceExec.get(getList + "/v2", { ...REMOVE_EMPTY_PARAMS(reqData) });
    if (ServiceExec.status.OK !== status) return;
    const { list, pageInfo } = data;
    if (isEmpty(list)) return;
    reqData.page = reqData.page + 1;
    commit('setCondition', reqData);
    commit('setPageInfo', pageInfo);
    commit('setMemorials', list);
  },

  async getDetail({ commit, getters, state }, memorialNo) {
    const { data, status } = await ServiceExec.get(getDetail + memorialNo);
    if (ServiceExec.status.OK !== status) return;
    commit('setDetail', data ?? '');
  },

  async getChurchMemorials({ commit, getters, state }, churchNo) {
    const condition = getters['getChurchCondition'];
    if (condition.page > state.churchPageInfo.totalPage) return;
    const memorialType = getters['getMemorialType'];
    condition.isInside = memorialType === MEMORIAL_TYPE.INSIDE;
    if (!isEmpty(churchNo)) condition.churchNo = churchNo;
    const { data, status } = await ServiceExec.get(getChurchMemorials, {
      ...condition
    });
    if (ServiceExec.status.OK !== status) return;
    condition.page = condition.page + 1;
    commit('setChurchCondition', condition);
    commit('setPageInfo', data.pageInfo);
    commit('setChurchMemorials', data.list ?? []);
  },

  async getHistoryList({ commit, getters, state }, familyCode) {
    const condition = getters['getHistoryCondition'];
    condition.familyCode = familyCode;
    const { data, status } = await ServiceExec.get(getHistoryList, condition);
    if (ServiceExec.status.OK !== status) return;
    condition.page = condition.page + 1;
    commit('setHistoryCondition', condition);
    commit('setHistoryList', data ?? []);
  },

  async getComment({ commit, getters, state }, memorialNo) {
    const condition = getters['getCommentCondition'];
    const pageInfo = getters['getPageInfo'];

    if (condition.page > pageInfo.totalPage) return false;

    condition.memorialNo = memorialNo;
    const { data, status } = await ServiceExec.get(getComment, {
      ...condition
    });
    if (status !== ServiceExec.status.OK) return false;

    commit('setCommentPage', condition.page + 1);
    commit('setPageInfo', data.pageInfo);
    commit('setCommentList', data.list ?? []);
  },

  async pushComment({ commit, getters, state }, payload) {
    const reqData = cloneDeep(payload);

    const { status, data } = await ServiceExec.post(pushComment, reqData);
    if (status !== ServiceExec.status.OK) return false;
    commit('appendComment', data);
  },

  async getAliveList({ commit, getters, state }, memorialNo) {
    const condition = getters['getAliveCondition'];
    condition.memorialNo = memorialNo;
    const { data, status } = await ServiceExec.get(getAliveList, condition);
    if (ServiceExec.status.OK !== status) return;
    condition.page = condition.page + 1;
    commit('setAliveCondition', condition);
    commit('setAliveList', data.list ?? []);
  },

  async getAliveDetail({ commit, getters, state }, aliveNo) {
    const { data, status } = await ServiceExec.get(getAliveDetail + aliveNo);
    if (ServiceExec.status.OK !== status) return;
    commit('setAliveDetail', data ?? '');
  },

  async addAlive({ commit, getters, state }, payload) {
    const { userNo } = store.getters['user/getUserData'];
    const reqParams = cloneDeep({ ...payload, userNo });
    const { status } = await ServiceExec.multiPost(saveAlive, asFormData(REMOVE_EMPTY_PARAMS(reqParams)));
    return ServiceExec.status.OK === status;
  },

  async updateAlive({ commit, getters, state }, payload) {
    const { userNo } = store.getters['user/getUserData'];
    const reqParams = cloneDeep({ ...payload, userNo });
    const { status } = await ServiceExec.multiPut(updateAlive, asFormData(REMOVE_EMPTY_PARAMS(reqParams)));
    return ServiceExec.status.OK === status;
  },
  async addReport({ commit, getters, state }, payload) {
    const { status } = await ServiceExec.post(addReport, payload);
    if (status !== ServiceExec.status.OK) return false;
  },

  /**
   * 생전모습 삭제
   * @param payload
   * - aliveNo 생전모습번호
   * - userNo 유저번호
   * @return {Promise<boolean>}
   */
  async deleteAlive({ commit, getters, state }, payload) {
    const { status } = await ServiceExec.patch(deleteAlive(payload.aliveNo));
    return status === ServiceExec.status.OK;
  },

  async deleteMemorial({ commit, getters, state }, memorialNo) {
    const { status } = await ServiceExec.patch(deleteMemorial + memorialNo);
    return status === ServiceExec.status.OK;
  },

  async saveMemorial({ commit, getters, state }, stepFourData) {
    const stepFour = cloneDeep(stepFourData);

    if (stepFour.isProductImage) {
      delete stepFour.backgroundRawFile;
    } else {
      stepFour.backgroundImageNo = store.getters['cry_gallery/getSelectedImage'].id;
    }

    const register = getters['getRegister'];

    Object.assign(register.step4, stepFour);
    register.step4.userNo = store.getters['user/getUserData']?.userNo;
    // register.step4.churchNo = userData.churchNo;
    // register.step4.familyCode = userData.representFamilyCode;

    if (!register.step1.isCouple) delete register.step2[1];
    for (let step2 of register.step2) {
      delete step2?.imageFile;
      delete step2?.preViewImage;
    }

    let memorialType = getters['getMemorialType'];
    const reqData = asFormData({
      ...register.step1,
      deadList: register.step2,
      anniversaryList: register.step3,
      ...register.step4,
      memorialType
    });

    // 260903 교회 성도 채널(코드=자격) — 저장 직전에 1회용 그랜트 토큰을 받아 폼에 실어 보낸다.
    //   /api/memorial/save 는 xss-ignore(/api/**/save) 글롭 → web.ignoring() 이라 JwtFilter 가 아예 안 돈다.
    //   즉 그 경로에서는 서버가 로그인 사용자를 알 방법이 없다(폼의 userNo 는 클라 값이라 못 믿는다).
    //   그래서 **인증이 도는 지금** 토큰을 받아 두고, 서버는 그 토큰 행에서 소유자·교회를 읽는다
    //   (MemorialSaveRequest.churchGrant → MemorialService.resolveGrantOwner).
    //   교회 이용권(-2)을 고르지 않았으면 이 블록을 통째로 건너뛰어 종전과 완전히 같은 요청이 나간다.
    if (Number(register.step1.itemHistoryNo) === -2) {
      // 260904 목록에서 고른 교회(memorial/churchNo)로 그랜트를 받는다 — 없으면 서버가 최근 자격으로 폴백(종전 동작).
      const churchNo = getters['getChurchNo'];
      const grantRes = await ServiceExec.post(churchGrant, churchNo ? { churchNo } : {});
      // ⚠️ 응답 키는 grantToken 이다(BE MemorialChurchService.issueGrant). token 으로 읽으면 늘 빈 값이 되어
      //   교회 채널 저장이 100% 실패하는데 서버 호출은 200이라 로그에도 안 남는다.
      const token = grantRes?.status === ServiceExec.status.OK ? grantRes?.data?.grantToken : '';
      if (!token) {
        // 토큰 없이 보내면 서버가 '이용권 없음'으로 되돌린다 — 사유가 엉뚱해지므로 여기서 끊는다.
        showTextModal('교회 성도 자격을 확인하지 못했습니다. 잠시 후 다시 시도해 주십시오.', '확인');
        return false;
      }
      reqData.append('churchGrant', token);
    }

    const { status, data } = await ServiceExec.multiPost(saveMemorial, reqData);
    if (status !== ServiceExec.status.OK) return false;
    return data;
  },

  /**
   * 추모관 수정
   * @param commit
   * @param getters
   * @param state
   * @param stepFourData
   * @returns {Promise<boolean>}
   */
  async editMemorial({ commit, getters, state }, stepFourData) {
    const { userNo, familyCode } = store.getters['user/getUserData'];
    const stepFour = cloneDeep(stepFourData);

    const register = cloneDeep(getters['getRegister']);

    Object.assign(register.step4, stepFour);
    register.step1.isInside = MEMORIAL_TYPE.INSIDE === register.step1.memorialType;
    register.step4.userNo = userNo;
    register.step4.familyCode = familyCode;

    if (!register.step1.isCouple) delete register.step2[1];
    for (let step2 of register.step2) {
      delete step2?.imageFile;
      delete step2?.preViewImage;
      delete step2?.file;
    }
    const reqData = asFormData(
      REMOVE_EMPTY_PARAMS({
        ...register.step1,
        deadList: register.step2,
        anniversaryList: register.step3,
        ...register.step4
      })
    );

    const { status } = await ServiceExec.multiPut(editMemorial, reqData);
    return status === ServiceExec.status.OK;
  },

  async getBackgroundImage({ commit, getters, state }) {
    const userData = store.getters['user/getUserData'];
    const { data, status } = await ServiceExec.get(getBackground(userData.userNo));
    if (ServiceExec.status.OK !== status) return false;
    commit('setBackground', data ?? []);

    return true;
  },

  async getBackgroundVideo({ commit, getters, state }) {
    const userData = store.getters['user/getUserData'];
    const { data, status } = await ServiceExec.get(getBackgroundVideo(userData.userNo));
    if (ServiceExec.status.OK !== status) return;
    commit('setBackground', data ?? []);

    return true;
  },

  async getAndersen_Background({ commit, getters, state }) {
    const { data, status } = await ServiceExec.get(getAndersenBackground);
    if (ServiceExec.status.OK !== status) return;
    commit('setBackground', data ?? []);

    return true;
  },

  async getFrame({ commit, getters, state }) {
    const { data, status } = await ServiceExec.get(getFrame);
    if (ServiceExec.status.OK !== status) return;
    commit('setFrame', data ?? '');
  },

  async fetchAnniversary({ commit, getters, state }, memorialNo) {
    const { data, status } = await ServiceExec.get(getAnniversary(memorialNo));
    if (ServiceExec.status.OK !== status) return;
    commit('setAnniversaryList', data ?? '');
  }
};
